module.exports = __webpack_public_path__ + "static/media/logo.5a2849b2.png";